var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52941 0.529412C9.52941 0.237026 9.76644 0 10.0588 0H17.4706C17.763 0 18 0.237026 18 0.529412V5.82353C18 6.11592 17.763 6.35294 17.4706 6.35294H10.0588C9.76644 6.35294 9.52941 6.11592 9.52941 5.82353V0.529412ZM10.0588 18C9.76644 18 9.52941 17.763 9.52941 17.4706V7.94118C9.52941 7.64879 9.76644 7.41177 10.0588 7.41177H17.4706C17.763 7.41177 18 7.64879 18 7.94118V17.4706C18 17.763 17.763 18 17.4706 18H10.0588ZM0.529412 18C0.237026 18 0 17.763 0 17.4706V12.1765C0 11.8841 0.237026 11.6471 0.529412 11.6471H7.94118C8.23356 11.6471 8.47059 11.8841 8.47059 12.1765V17.4706C8.47059 17.763 8.23356 18 7.94118 18H0.529412ZM0.529412 10.5882C0.237026 10.5882 0 10.3512 0 10.0588V0.529412C0 0.237026 0.237026 0 0.529412 0H7.94118C8.23356 0 8.47059 0.237026 8.47059 0.529412V10.0588C8.47059 10.3512 8.23356 10.5882 7.94118 10.5882H0.529412ZM1.05882 1.05882V9.52941H7.41177V1.05882H1.05882ZM10.5882 1.05882V5.29412H16.9412V1.05882H10.5882ZM10.5882 8.47059V16.9412H16.9412V8.47059H10.5882ZM1.05882 12.7059V16.9412H7.41177V12.7059H1.05882Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioDashboard);
export default __webpack_public_path__ + "static/media/portfolioDashboard.3b14675f0fab8281e8654a0b6fe47e9a.svg";
export { ForwardRef as ReactComponent };